require('./RACircularGoalIcon.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @constants
const {
    RA_GOAL_NOTIFICATION_MODIFIER_INFORMATIVE,
    RA_GOAL_NOTIFICATION_MODIFIER_SUCCESS,
    RA_GOAL_NOTIFICATION_MODIFIER_WARNING,
} = require('../../raConstants/index');

class RACircularGoalIcon extends React.Component {
    render() {
        const { type, modifier, size } = this.props;
        const iconModifier = type.toLowerCase();
        const innerCircleClassName = classnames(
            'ra-circular-goal-icon__inner-circle',
            {
                'ra-circular-goal-icon__inner-circle--placeholder': !iconModifier,
            },
        );
        const innerIconClassName = classnames({
            ['icon ra-circular-goal-icon__image ra-circular-goal-icon__image--' +
            iconModifier]: !!iconModifier,
            ['icon icon-nuevos-objetivos ra-circular-goal-icon__placeholder']: !iconModifier,
        });
        const smallIconClassName = classnames(
            'ra-circular-goal-icon__small-icon',
            `ra-circular-goal-icon__small-icon--${size}`,
            {
                ['ra-circular-goal-icon__small-icon--' + modifier]: !!modifier,
            },
        );
        const outerCircleClassName = classnames(
            'ra-circular-goal-icon__outer-circle',
            `ra-circular-goal-icon__outer-circle--${size}`,
        );

        return (
            <div className="ra-circular-goal-icon">
                <div className={outerCircleClassName}>
                    <div className={innerCircleClassName}>
                        <i className={innerIconClassName} />
                        <i className={smallIconClassName} />
                    </div>
                </div>
            </div>
        );
    }
}

RACircularGoalIcon.propTypes = {
    type: PropTypes.string,
    modifier: PropTypes.oneOf([
        RA_GOAL_NOTIFICATION_MODIFIER_SUCCESS,
        RA_GOAL_NOTIFICATION_MODIFIER_WARNING,
        RA_GOAL_NOTIFICATION_MODIFIER_INFORMATIVE,
    ]),
    size: PropTypes.oneOf(['medium', 'small']),
};

RACircularGoalIcon.defaultProps = {
    type: '',
    modifier: '',
    size: 'medium',
};

module.exports = RACircularGoalIcon;
